import { IsInt } from 'class-validator';

export class WidgetDeleteRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<WidgetDeleteRequest>) {
        this.id = data?.id;
    }
}
